// Serviço centralizado para gerenciamento do localStorage no Register
import { STORAGE_KEYS } from "../utils/constants";
import logger from "../../../utils/logger";

export const storageService = {
  /**
   * Recupera a região atual
   * @returns {string|null} Região ou null
   */
  getRegion: () => {
    return localStorage.getItem("region");
  },

  /**
   * Recupera plots salvos
   * @returns {Array} Array de plots ou array vazio
   */
  getPlots: () => {
    try {
      const plots = localStorage.getItem(STORAGE_KEYS.ALL_PLOTS);
      if (!plots) return [];

      const parsed = JSON.parse(plots);
      
      // Garantir que seja um array
      if (Array.isArray(parsed)) {
        return parsed;
      }
      
      // Se for objeto, tentar extrair dados
      if (parsed && typeof parsed === "object" && parsed.dados && Array.isArray(parsed.dados)) {
        return parsed.dados;
      }
      
      return [];
    } catch (error) {
      logger.error("Erro ao parsear plots", error);
      return [];
    }
  },

  /**
   * Salva plots
   * @param {Array} plots - Array de plots
   */
  setPlots: (plots) => {
    localStorage.setItem(STORAGE_KEYS.ALL_PLOTS, JSON.stringify(plots));
  },

  /**
   * Recupera plot alternativo salvo
   * @returns {Object|null} Plot ou null
   */
  getRegisterPlotAlternate: () => {
    try {
      const plot = localStorage.getItem(STORAGE_KEYS.REGISTER_PLOT_ALTERNATE);
      if (!plot) return null;
      return JSON.parse(plot);
    } catch (error) {
      logger.error("Erro ao parsear plot alternativo", error);
      return null;
    }
  },

  /**
   * Salva plot alternativo
   * @param {Object} plot - Plot a ser salvo
   */
  setRegisterPlotAlternate: (plot) => {
    localStorage.setItem(STORAGE_KEYS.REGISTER_PLOT_ALTERNATE, JSON.stringify(plot));
  },

  /**
   * Remove plot alternativo
   */
  removeRegisterPlotAlternate: () => {
    localStorage.removeItem(STORAGE_KEYS.REGISTER_PLOT_ALTERNATE);
  },

  /**
   * Recupera registros para convite (offline)
   * @returns {Array} Array de registros
   */
  getRegistersToInvite: () => {
    try {
      const registers = localStorage.getItem(STORAGE_KEYS.REGISTERS_TO_INVITE);
      if (!registers) return [];
      return JSON.parse(registers);
    } catch (error) {
      logger.error("Erro ao parsear registros para convite", error);
      return [];
    }
  },

  /**
   * Salva registros para convite (offline)
   * @param {Array} registers - Array de registros
   */
  setRegistersToInvite: (registers) => {
    localStorage.setItem(STORAGE_KEYS.REGISTERS_TO_INVITE, JSON.stringify(registers));
  },

  /**
   * Remove registros para convite
   */
  removeRegistersToInvite: () => {
    localStorage.removeItem(STORAGE_KEYS.REGISTERS_TO_INVITE);
  }
};

